/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Full_WeekInputs */

const en_coaches_full_week = /** @type {(inputs: Coaches_Full_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the full week`)
};

const pl_coaches_full_week = /** @type {(inputs: Coaches_Full_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz cały tydzień`)
};

/**
* | output |
* | --- |
* | "See the full week" |
*
* @param {Coaches_Full_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_full_week = /** @type {((inputs?: Coaches_Full_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Full_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_full_week(inputs)
	return en_coaches_full_week(inputs)
});